export * from "./NewClassPage";
